import styled from 'styled-components';
import { FlexCol } from '../shared/Flex';
import { MouseEvent, ReactNode } from 'react';
import { Nav } from './Nav';

const StyledPage = styled.div`
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	background: ${({ theme }) => theme.background};
`;

const StyledPageWrapper = styled(FlexCol)`
	padding-top: 67px;
`;

export function Page({
	children,
	actions,
}: {
	children: ReactNode;
	actions?: { text: string; action: (e: MouseEvent) => void; disabled?: boolean }[];
}) {
	return (
		<StyledPage>
			<Nav actions={actions} />
			<StyledPageWrapper>{children}</StyledPageWrapper>
		</StyledPage>
	);
}

export function PageEmpty({ children }: { children: ReactNode }) {
	return (
		<StyledPage>
			<StyledPageWrapper>{children}</StyledPageWrapper>
		</StyledPage>
	);
}
